import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = {
  key: 0,
  class: "mt-1.5 flex gap-[3px]",
  "aria-hidden": "true"
}
const _hoisted_3 = ["data-testid"]

import { computed } from 'vue'

import { QUEUE_TONE_PILL_CLASS } from '@/components/designSystem/QueueViews/types'
import type { PackageStage } from '@/Network/Types/Responses/AntecipeAffiliateResponses'

import { PACKAGE_STAGE_LABELS, stageSteps, stageTone } from '../labels'
import type { StageStep } from '../labels'


export default /*#__PURE__*/_defineComponent({
  __name: 'AffiliateStageCell',
  props: {
    stage: {},
    showSteps: { type: Boolean, default: true },
    testId: { default: 'affiliate-stage-cell' }
  },
  setup(__props: any) {

const props = __props;



const STEP_CLASS: Record<StageStep, string> = {
  done: 'bg-primary',
  current: 'bg-blue-500',
  todo: 'bg-lightGray30',
  canceled: 'bg-[#7F7F8E]'
}

const steps = computed(() => stageSteps(props.stage))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex flex-col",
    "data-testid": _ctx.testId
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["inline-flex w-fit items-center whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium", _unref(QUEUE_TONE_PILL_CLASS)[_unref(stageTone)(_ctx.stage)]])
    }, _toDisplayString(_unref(PACKAGE_STAGE_LABELS)[_ctx.stage]), 3),
    (_ctx.showSteps)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (step, index) => {
            return (_openBlock(), _createElementBlock("i", {
              key: index,
              class: _normalizeClass(["block h-[5px] w-[18px] rounded-sm", STEP_CLASS[step]]),
              "data-testid": `${_ctx.testId}-step-${index}`
            }, null, 10, _hoisted_3))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})